import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StickyMobileBar from "./components/StickyMobileBar";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Scooter from "./pages/Scooter";
import OfficinaMoto from "./pages/OfficinaMoto";
import OfficinaBici from "./pages/OfficinaBici";
import Contatti from "./pages/Contatti";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main className="flex-1" data-testid="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/scooter" element={<Scooter />} />
            <Route path="/officina-moto" element={<OfficinaMoto />} />
            <Route path="/officina-bici" element={<OfficinaBici />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <StickyMobileBar />
      </div>
    </BrowserRouter>
  );
}

export default App;
